<template>
  <ModalEdit
    :id="modalId"
    :title="$t('text.addNote')"
    :loading="isLoading"
    @click="onSubmit"
    @onClickCancel="resetForm"
  >
    <div class="p-5" style="color: #000;">
      <InputDate
        v-model="$v.form.contractStartDate.$model"
        :vuelidate="$v.form.contractStartDate"
        :label="$t('text.customerInfoContractStartDate')"
      />
      <InputDate
        v-model="$v.form.contractEndDate.$model"
        :vuelidate="$v.form.contractEndDate"
        :label="$t('text.customerInfoContractEndDate')"
      />
    </div>
  </ModalEdit>
</template>

<script>
import { mapGetters } from 'vuex';
import { CUSTOMER_UPDATE_CONTRACT_DATE } from '@/store/actions/customer';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalEdit from '@/components/ui/ModalEdit';
import baseModalMixin from '@/mixins/baseModalMixin';
import InputDate from '@/components/ui/input/InputDate';

export default {
  mixins: [validationMixin, baseModalMixin],

  components: {
    ModalEdit,
    InputDate,
  },

  props: {
    customer: Object,
  },

  validations() {
    return {
      form: {
        contractStartDate: {
          required,
        },
        contractEndDate: {
          required,
        },
      },
    };
  },

  data() {
    return {
      form: {
        contractStartDate: '',
        contractEndDate: '',
      },
    };
  },

  watch: {
    customer: {
      handler(customer) {
        if (customer) {
          this.form = {
            contractStartDate: customer.contractStartDate,
            contractEndDate: customer.contractEndDate,
          };
        }
      },
    },
  },

  computed: {
    ...mapGetters(['customerUpdateContractDateStatus']),
    isLoading() {
      return this.customerUpdateContractDateStatus === 'loading';
    },
  },

  methods: {
    resetForm() {
      this.form = {
        contractStartDate: '',
        contractEndDate: '',
      };
      this.$v.$reset();
    },
    async onSubmit() {
      if (this.$v) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toasted.show(this.$t('toast.failedForm'), { type: 'error' });
          return;
        }
      }

      const payload = {
        id: this.customer.id,
        data: this.form,
      };

      await this.$store.dispatch(CUSTOMER_UPDATE_CONTRACT_DATE, payload);

      if (this.customerUpdateContractDateStatus === 'success') {
        this.$toasted.show(this.$t('toast.success'), { type: 'success' });
        this.hideEditModal();
        this.resetForm();
      }
    },
  },
};
</script>
